import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFavorites } from '../../context/FavoritesContext';
import pb from '../../services/pocketbase';
import OrderSummaryModal from '../OrderSummaryModal/OrderSummaryModal';
import './FavoritesSidebar.css';

function FavoritesSidebar() {
  const navigate = useNavigate();
  const { favorites, isSidebarOpen, toggleSidebar, removeFromFavorites, totalPrice } = useFavorites();
  const [showOrderModal, setShowOrderModal] = useState(false);

  const getImageUrl = (item) => {
    const imageName = Array.isArray(item.image) ? item.image[0] : item.image;
    if (item && imageName && item.collectionId && item.id) {
      return pb.files.getURL({
        collectionId: item.collectionId,
        id: item.id
      }, imageName, {'thumb': '100x100'});
    }
    return 'https://via.placeholder.com/100'; // Placeholder image
  };

  return (
    <>
      <div 
        className={`sidebar-overlay ${isSidebarOpen ? 'show' : ''}`}
        onClick={toggleSidebar}
      ></div>
      <aside className={`favorites-sidebar ${isSidebarOpen ? 'open' : ''}`}>
        <header className="sidebar-header">
          <h3>Vos Favoris</h3>
          <button onClick={toggleSidebar} className="close-btn">&times;</button>
        </header>
        <div className="sidebar-content">
          {favorites.length === 0 ? (
            <p className="empty-message">Votre liste de favoris est vide.</p>
          ) : (
            <ul className="favorites-list">
              {favorites.map(item => {
                // Sécurité : ne rien afficher si l'item est invalide
                if (!item || typeof item.name === 'undefined' || typeof item.price === 'undefined') {
                  return null;
                }

                return (
                  <li key={item.id} className="favorite-item">
                    <img 
                      src={getImageUrl(item)} 
                      alt={item.name}
                      onClick={() => navigate(`/catalogue/produit/${item.slug}`)}
                      style={{ cursor: 'pointer' }}
                    />
                    <div className="item-details">
                      <span 
                        className="item-name"
                        onClick={() => navigate(`/catalogue/produit/${item.slug}`)}
                        style={{ cursor: 'pointer' }}
                      >
                        {item.name}
                      </span>
                      <span className="item-price">{(item.price || 0).toFixed(2).replace('.', ',')} €</span>
                    </div>
                    <button onClick={() => removeFromFavorites(item.id)} className="remove-btn">
                      &times;
                    </button>
                  </li>
                );
              })}
            </ul>
          )}
        </div>
        <footer className="sidebar-footer">
          <div className="total-price">
            <span>Total</span>
            <span>{totalPrice.toFixed(2).replace('.', ',')} €</span>
          </div>
          <div className="shipping-notice">
            *Frais de livraison non inclus
          </div>
          <button 
            className="checkout-btn" 
            disabled={favorites.length === 0}
            onClick={() => setShowOrderModal(true)}
          >
            Contacter pour commander
          </button>
        </footer>
      </aside>
      
      <OrderSummaryModal
        isOpen={showOrderModal}
        onClose={() => setShowOrderModal(false)}
        items={favorites}
        total={totalPrice}
        type="favorites"
      />
    </>
  );
}

export default FavoritesSidebar;